import experimentFlagsHelper from '@zola-helpers/client/dist/es/util/experimentFlagsHelper';

// LogRocket Keys
export const LOGROCKET_REGISTRY_WEDDING_WEBSITE = 'logrocket-registry-wedding-website'; //
export const LOGROCKET_ALBUM_CUSTOMIZATION = 'logrocket-album-customization'; // COMMERCE-172 https://newamsterdamlabs.atlassian.net/browse/COMMERCE-172
export const LOGROCKET_PLANNING_ONBOARD_FLAG = 'logrocket-planning-onboard';
export const LOGROCKET_WEBSITE_ONBOARD = 'logrocket-website-onboard';
export const SUPER_LINK_LOG_ROCKET = 'magic-link-log-rocket'; // CE-847 https://newamsterdamlabs.atlassian.net/browse/CE-847
export const LOGROCKET_INVITES_PLP = 'logrocket-invites-plp'; // COMMERCE-584 https://newamsterdamlabs.atlassian.net/browse/COMMERCE-584
export const LOGROCKET_INVITES_PDP = 'logrocket-invites-pdp'; // COMMERCE-585 https://newamsterdamlabs.atlassian.net/browse/COMMERCE-585

// Experiment Keys
export const CARDS_PDP_REFRESH = 'cards-pdp-refresh';
export const CARDS_MOBILE_FILTERS = 'cards-mobile-filters';
export const REGISTRY_GIFT_GIVER_TILE_HEIGHT = 'registry-gift-giver-tile-height'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-929
export const REGISTRY_GIFT_GIVER_PRE_FILTERED = 'registry-gift-giver-pre-filtered'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-930
export const REGISTRY_GIFT_GIVER_PDP_BADGE = 'registry-gift-giver-pdp-badge'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-931
export const HOME_NEWNESS = 'home-newness';
export const DESKTOP_TO_APP_ENABLED = 'desktop-to-app-enabled'; // https://newamsterdamlabs.atlassian.net/browse/CE-1417
export const GUEST_LIST_DESK_TO_APP = 'guest_list_desk_to_app'; // https://newamsterdamlabs.atlassian.net/browse/CE-1352
export const WEBSITE_CUSTOMIZATION_ENABLED = 'website-customization-enabled'; // https://newamsterdamlabs.atlassian.net/browse/CE-1636
export const CARDS_SAMPLES_FLOW = 'cards-samples-flow'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-1014
export const CARDS_PDP_LIVE_PREVIEW = 'cards-pdp-live-preview';
export const POST_ONBOARDING_RW = 'post-onboarding-rw';
export const DSTD_WEDDING_WEBSITE_ENTRYPOINT = 'dstd-wedding-website-entrypoint-ii'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-1133
export const HDYHAU_SUBWAY = 'hdyhau-subway';
export const DSTD_NAV_ENTRY = 'dstd-navigation-entry';
export const WEBSITE_TO_REGISTRY_V2 = 'website-to-registry-v2'; // https://newamsterdamlabs.atlassian.net/browse/CE-1848
export const CHAR_COUNT_INCREASE = 'website-char-count-increase'; // https://newamsterdamlabs.atlassian.net/browse/CE-1876
export const CARDS_CUSTOMIZATION_PANEL = 'cards-customization-panel'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-1328
export const SINGLE_PAGE_WEBSITE_ONBOARDING = 'single-page-website-onboarding';
export const GALLERY_MULTI_PHOTO = 'gallery-multi-photo'; // https://newamsterdamlabs.atlassian.net/browse/CE-1972
export const INVITES_PROMO_HIDE = 'invites-promo-hide'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-1629
export const SUPER_LINK_SAMPLES = 'super-link-samples-modal'; // https://newamsterdamlabs.atlassian.net/browse/CE-2052
export const SUPER_LINK_LANDING = 'super-link-landing'; // https://newamsterdamlabs.atlassian.net/browse/CE-2052

// Promo flags
export const INVITES_PROMO_PAPER40 = 'invites-promo-paper40';
export const ALBUMS_PROMO_ALBUMS25 = 'albums25';
export const STD_PROMO_50FREE = 'std-promo-50free';
export const HOLIDAY_PROMO_HOLIDAY50 = 'holiday-promo-holiday50';

const FALLBACK_VARIATIONS = {
  // LogRocket Flags
  [LOGROCKET_PLANNING_ONBOARD_FLAG]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_WEBSITE_ONBOARD]: experimentFlagsHelper.createExperimentFlags(),
  [SUPER_LINK_LOG_ROCKET]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_ALBUM_CUSTOMIZATION]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_REGISTRY_WEDDING_WEBSITE]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_INVITES_PLP]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_INVITES_PDP]: experimentFlagsHelper.createExperimentFlags(),
  // Experiment Flags
  [CARDS_PDP_REFRESH]: experimentFlagsHelper.createExperimentFlags(),
  [HOME_NEWNESS]: experimentFlagsHelper.createExperimentFlags(),
  [REGISTRY_GIFT_GIVER_TILE_HEIGHT]: experimentFlagsHelper.createExperimentFlags(),
  [REGISTRY_GIFT_GIVER_PRE_FILTERED]: experimentFlagsHelper.createExperimentFlags(),
  [REGISTRY_GIFT_GIVER_PDP_BADGE]: experimentFlagsHelper.createExperimentFlags(),
  [CARDS_MOBILE_FILTERS]: experimentFlagsHelper.createExperimentFlags(),
  [DESKTOP_TO_APP_ENABLED]: experimentFlagsHelper.createExperimentFlags(),
  [GUEST_LIST_DESK_TO_APP]: experimentFlagsHelper.createExperimentFlags(),
  [WEBSITE_CUSTOMIZATION_ENABLED]: experimentFlagsHelper.createExperimentFlags(),
  [CARDS_SAMPLES_FLOW]: experimentFlagsHelper.createExperimentFlags(),
  [CARDS_PDP_LIVE_PREVIEW]: experimentFlagsHelper.createExperimentFlags(),
  [POST_ONBOARDING_RW]: experimentFlagsHelper.createExperimentFlags(),
  [DSTD_WEDDING_WEBSITE_ENTRYPOINT]: experimentFlagsHelper.createExperimentFlags(),
  [HDYHAU_SUBWAY]: experimentFlagsHelper.createExperimentFlags(),
  [DSTD_NAV_ENTRY]: experimentFlagsHelper.createExperimentFlags(),
  [INVITES_PROMO_PAPER40]: experimentFlagsHelper.createExperimentFlags(),
  [ALBUMS_PROMO_ALBUMS25]: experimentFlagsHelper.createExperimentFlags(),
  [STD_PROMO_50FREE]: experimentFlagsHelper.createExperimentFlags(),
  [HOLIDAY_PROMO_HOLIDAY50]: experimentFlagsHelper.createExperimentFlags(),
  [CARDS_CUSTOMIZATION_PANEL]: experimentFlagsHelper.createExperimentFlags(),
  [GALLERY_MULTI_PHOTO]: experimentFlagsHelper.createExperimentFlags(),
  [INVITES_PROMO_HIDE]: experimentFlagsHelper.createExperimentFlags(),
  [SUPER_LINK_SAMPLES]: experimentFlagsHelper.createExperimentFlags(),
  [SUPER_LINK_LANDING]: experimentFlagsHelper.createExperimentFlags(),
};

export default experimentFlagsHelper.makeExperimentFlags(FALLBACK_VARIATIONS);
